module.exports = __webpack_public_path__ + "excl-red.svg?99bc9abc641bfc8d945dd3648ac087b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/excl-red.svg
// module id = 933
// module chunks = 0